import Modal from '../modal'
import React from 'react'
import { Button } from '@mission.io/styles'
import classnames from 'classnames'

/**
 * A modal to confirm an action before it is performed.
 * This modal is styled similar to a dashboard confirmation modal.
 *
 * @param {cb~onCancel} onCancel callback to cancel action, should close the modal by setting isOpen to false
 * @param {cb~onConfirm} onConfirm callback to confirm action.
 * @param {boolean} isOpen whether the modal is open or not
 * @param {string} confirmText text for the button that will confirm the action when clicked, defaults to 'Ok' *
 * @returns {JSX.Element}
 */
export default function ConfirmationModal({
	onCancel,
	onConfirm,
	isOpen,
	children,
	confirmText = 'Ok',
	className,
	...rest
}: {
	isOpen: boolean
	onCancel: () => void
	onConfirm: () => void
	children: React.ReactNode
	confirmText?: string
	parentSelector?: HTMLElement
	className?: string
}): JSX.Element {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onCancel}
			{...rest}
			className={classnames(className, 'overflow-hidden')}>
			<div className="p-6 bg-brand-cloud-blue">{children}</div>
			<div className="flex justify-end bg-brand-deep-blue p-2 gap-2">
				<Button outline onClick={onCancel}>
					Cancel
				</Button>
				<Button onClick={onConfirm}>{confirmText}</Button>
			</div>
		</Modal>
	)
}
